module.exports = __webpack_public_path__ + "media/images/interviewee_hatena-c386a253e4d2180b2b53114f8b025e98.png";